angular.module( 'acme.view.application.templates.create.schedules.create.tickets', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.templates.create.schedules.create.tickets.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var templatesCreateSchedulesCreateTickets = {
        name: 'application.templates.create.schedules.create.tickets',
        url: '/tickets',
        views: {
          "subview-main": {
            controller: 'TemplatesCreateSchedulesCreateTicketsController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/templates/create/schedules/create/tickets/tickets.tpl.html'
          }
        },
        data: {
          pageTitle: 'Create Event Template Schedule Ticket Layouts'
        }
    },templatesCreateSchedulesEditTickets = {
      name: 'application.templates.edit.schedules.edit.tickets',
      url: '/tickets',
      views: {
        "subview-main": {
          controller: 'TemplatesCreateSchedulesCreateTicketsController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/schedules/create/tickets/tickets.tpl.html'
        }
      },
      data: {
        pageTitle: 'Edit Event Template Schedule Ticket Layouts'
      }
    };

    $stateProvider
      .state(templatesCreateSchedulesCreateTickets)
      .state(templatesCreateSchedulesEditTickets);

});
